import { fabric } from 'fabric';
import BaseHandler from './BaseHandler';
import {
  FONT_SCALE_FACTOR,
  SCALE_FACTOR,
} from 'components/Canvas/common/constants';

class RotationLabelHandler extends BaseHandler {
  constructor(props) {
    super(props);
    this.init();
  }

  init() {
    // --- Extend fabric.Object to add rotation label ---
    fabric.Object.prototype._drawRotationLabel = function (ctx) {
      if (!this.__isRotating) return;

      const angle = Math.round(this.angle % 360);

      // Get object coords (in canvas space)
      const coords = this.getCoords();

      // Top-left and top-right
      const topLeft = coords[0];
      const topRight = coords[1];

      // Midpoint of the top edge (top-center)
      const topCenter = {
        x: (topLeft.x + topRight.x) / 2,
        y: (topLeft.y + topRight.y) / 2,
      };

      // Vector along the top edge
      const edgeX = topRight.x - topLeft.x;
      const edgeY = topRight.y - topLeft.y;
      const edgeLen = Math.sqrt(edgeX * edgeX + edgeY * edgeY);

      // Normalized perpendicular vector (pointing outward above the top edge)
      const px = edgeY / edgeLen;
      const py = -edgeX / edgeLen;

      // Push label outward from the top-center
      const offset = 70; // <-- increase this to move it farther away
      const labelX = topCenter.x + px * offset;
      const labelY = topCenter.y + py * offset;

      const fontSize = (16 / SCALE_FACTOR) * FONT_SCALE_FACTOR;

      ctx.save();

      ctx.font = `${fontSize}px Arial`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      const text = `${angle}°`;
      const padding = 10;
      const textMetrics = ctx.measureText(text);
      const textWidth = textMetrics.width;
      const textHeight = fontSize; // approximation
      const boxWidth = textWidth + padding * 2;
      const boxHeight = textHeight + padding * 1.6;
      const radius = 6; // rounded corner radius

      // Draw rounded rect background (centered on labelX/labelY)
      ctx.fillStyle = 'rgba(0, 0, 0, 0.8)'; // semi-transparent black
      ctx.beginPath();
      const x = labelX - boxWidth / 2;
      const y = labelY - boxHeight / 1.85;

      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + boxWidth - radius, y);
      ctx.quadraticCurveTo(x + boxWidth, y, x + boxWidth, y + radius);
      ctx.lineTo(x + boxWidth, y + boxHeight - radius);
      ctx.quadraticCurveTo(
        x + boxWidth,
        y + boxHeight,
        x + boxWidth - radius,
        y + boxHeight
      );
      ctx.lineTo(x + radius, y + boxHeight);
      ctx.quadraticCurveTo(x, y + boxHeight, x, y + boxHeight - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
      ctx.fill();

      // Draw text on top
      ctx.fillStyle = '#fff'; // white text
      ctx.fillText(text, labelX, labelY);

      ctx.restore();
    };

    // Monkey-patch renderControls to also draw rotation label
    const origRenderControls = fabric.Object.prototype._renderControls;
    fabric.Object.prototype._renderControls = function (ctx, options) {
      origRenderControls.call(this, ctx, options);
      this._drawRotationLabel(ctx);
    };

    // --- Canvas events to toggle rotation state ---
    this.canvas.on('object:rotating', e => {
      const obj = e.target;
      if (!obj) return;

      obj.__isRotating = true;

      if (e.e.shiftKey) {
        // Snap to nearest 15 degrees
        const snapped = Math.round(obj.angle / 15) * 15;
        obj.rotate(snapped);
      }

      this.canvas.requestRenderAll();
    });

    this.canvas.on('object:modified', e => {
      if (!e.target) return;

      // keep showing angle a bit longer
      setTimeout(() => {
        e.target.__isRotating = false;
        this.canvas.requestRenderAll();
      }, 500); // 500ms delay, adjust as needed
    });

    // Listen for shift + up/down to snap rotation
    // document.addEventListener('keydown', e => {
    //   const activeObj = this.canvas.getActiveObject();
    //   if (!activeObj) return;

    //   if (e.shiftKey && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
    //     // Prevent both browser scroll and Fabric key bindings
    //     e.preventDefault();
    //     e.stopPropagation();

    //     // mark as rotating so the label shows
    //     activeObj.__isRotating = true;

    //     if (e.key === 'ArrowUp') {
    //       activeObj.rotate((activeObj.angle || 0) + 15);
    //     } else if (e.key === 'ArrowDown') {
    //       activeObj.rotate((activeObj.angle || 0) - 15);
    //     }

    //     this.canvas.requestRenderAll();
    //   }
    // });

    // When key is released, hide the label again
    // document.addEventListener('keyup', e => {
    //   const activeObj = this.canvas.getActiveObject();
    //   if (!activeObj) return;

    //   if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    //     // keep label visible for 500ms after key release
    //     setTimeout(() => {
    //       activeObj.__isRotating = false;
    //       this.canvas.requestRenderAll();
    //     }, 500);
    //   }
    // });
  }
}

export default RotationLabelHandler;
